/**
 * Safely parse JSON with error handling
 * @param {string} jsonString - The JSON string to parse
 * @param {*} defaultValue - Default value if parsing fails
 * @returns {*} Parsed object or defaultValue
 */
export function safeJsonParse(jsonString, defaultValue = {}) {
  if (!jsonString) return defaultValue;
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    if (import.meta.env.DEV) {
      console.warn(`Failed to parse JSON: ${e.message}`);
    }
    return defaultValue;
  }
}

/**
 * Safely get and parse from localStorage
 * @param {string} key - Storage key
 * @param {*} defaultValue - Default value if key doesn't exist or parsing fails
 * @returns {*} Parsed value or defaultValue
 */
export function safeLocalStorageGet(key, defaultValue = {}) {
  const value = localStorage.getItem(key);
  return safeJsonParse(value, defaultValue);
}
